import { render, staticRenderFns } from "./ArchiveModalIcan.vue?vue&type=template&id=31a4cbaa&scoped=true"
import script from "./ArchiveModalIcan.vue?vue&type=script&lang=js"
export * from "./ArchiveModalIcan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31a4cbaa",
  null
  
)

export default component.exports